import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
// component, hooks
import ConfirmModal from "../../../../common/components/dialog/ConfirmModal";
// store
import { StoreContext } from "../../../../store/StoreProvider";
import Act from "../../../../store/actions";
// config,utils

// style

const ConfirmModalHoc = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale } = user;
  const { dialogContext } = sna;

  // local state
  // hooks

  const handleClose = () => {
    dispatch({
      type: Act.SNA_DIALOG_CONTEXT,
      payload: {
        title: "",
        contentText: "",
      },
    });
  };

  return <ConfirmModal {...dialogContext} onClose={handleClose} />;
};

ConfirmModalHoc.propTypes = {};

ConfirmModalHoc.defaultProps = {};

export default ConfirmModalHoc;
